import styled from "styled-components";
import { useState, useRef, useEffect } from "react";
import { gql, useQuery, useLazyQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import AutoresponderMessageEditor from "./AutoresponderMessageEditor";

export default ({ messageId }) => {
  const emailEditorRef = useRef();

  const [loadingSaveMessage, setLoadingSaveMessage] = useState(false);

  // Fetch data
  const GET_RESPONDER_MESSAGE_DATA = gql`
    query GetResponderMessageData($messageId: ID!) {
      responderMessageData(messageId: $messageId) {
        id
        design
        html
      }
    }
  `;

  const [responderMessageData] = useLazyQuery(GET_RESPONDER_MESSAGE_DATA);

  const onEditorReady = async (unlayer) => {
    console.log("Editor READY");

    if (messageId) {
      const { data, error } = await responderMessageData({
        variables: {
          messageId,
        },
        fetchPolicy: "network-only",
      });

      if (error) {
        console.log("error fetching responder message data", error);
        captureException(error);
      }

      console.log("data", data);

      if (data?.responderMessageData.design) {
        unlayer.loadDesign(data.responderMessageData.design);
      }
    }
  };

  // const openPreview = (id) => {
  //   navigate(`/`);
  // };

  // const onEditClick = (id) => {
  //   setEditingMessageId(id);
  //   setEditorOpened(true);
  // };

  const SUBMIT_AUTORESPONDER_MESSAGE = gql`
    mutation SubmitAutoresponderMessage(
      $messageId: ID
      $design: JSON!
      $html: String!
    ) {
      submitAutoresponderMessage(
        messageId: $messageId
        design: $design
        html: $html
      ) {
        resultCode
      }
    }
  `;

  const [submitAutoresponderMessage] = useMutation(
    SUBMIT_AUTORESPONDER_MESSAGE
  );

  const saveMessage = () => {
    const unlayer = emailEditorRef.current?.editor;

    if (!unlayer) return;

    setLoadingSaveMessage(true);

    unlayer?.exportHtml(async (data) => {
      try {
        const { design, html } = data;
        console.log("exportHtml", design, html);

        const result = await submitAutoresponderMessage({
          variables: { messageId, design, html },
        });

        const { resultCode } = result.data.submitAutoresponderMessage;
        console.log({ resultCode });
      } catch (error) {
        console.log("saveMessage error", error);
        captureException(error);
        setLoadingSaveMessage(false);
        return;
      }
    });
  };

  // const exportHtml = () => {
  //   const unlayer = emailEditorRef.current?.editor;

  //   unlayer?.exportHtml((data) => {
  //     const { design, html } = data;
  //     console.log("exportHtml", html);
  //   });
  // };

  return (
    <AutoresponderMessageEditor
      emailEditorRef={emailEditorRef}
      saveMessage={saveMessage}
      onEditorReady={onEditorReady}
    />
  );
};
